/**
 * Eagerly imports all shape SVGs as raw strings at build time via Vite's import.meta.glob.
 * Keys are the URL paths that the rest of the app uses as cache keys (e.g. '/static/asset/shapes/geometry2d/triangle.svg').
 * Consuming code checks this map via getSVGFromWindowCache, which looks here before making any XHR request.
 */
const svgModules = import.meta.glob('./assets/shapes/**/*.svg', { eager: true, query: '?raw', import: 'default' });

// Map './assets/shapes/geometry2d/triangle.svg' → '/static/asset/shapes/geometry2d/triangle.svg'
const bundledSVGs = {};
for (const [path, content] of Object.entries(svgModules)) {
    const urlKey = path.replace('./assets/shapes/', '/static/asset/shapes/');
    bundledSVGs[urlKey] = content;
}

export default bundledSVGs;
